import { DateTime as DateTime$1 } from "../../../../components/DateTime/index.js";
import { useMemo } from "react";
import { Badge, Button, Checkbox, DinnerTable, Icon } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { getDevice } from "@therms/web-js";
import { MdDone, MdSensors } from "react-icons/md";
//#region src/modules/Users/shared/UserAuthSessionsTable/TableRow.tsx
function UserAuthSessionsTableRow({ onClickAuthSessionClientApps, onSelectRow, onTestPushNotification, rowData, selectedRowKeys, showUserName }) {
	const device = getDevice();
	const clientAppsByName = useMemo(() => {
		if (!rowData.clientApps) return;
		return rowData.clientApps.reduce((acc, clientApp) => {
			const name = clientApp.appName;
			if (!acc[name]) acc[name] = [];
			acc[name].push(clientApp);
			return acc;
		}, {});
	}, [rowData]);
	return /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsxs(DinnerTable.Row, { children: [
		/* @__PURE__ */ jsx(DinnerTable.Cell, { children: /* @__PURE__ */ jsx("div", {
			className: "flex items-center justify-center",
			children: /* @__PURE__ */ jsx(Checkbox, {
				active: !!selectedRowKeys?.includes(rowData.publicId),
				onChangeValue: () => onSelectRow?.(rowData.publicId)
			})
		}) }),
		showUserName && /* @__PURE__ */ jsx(DinnerTable.Cell, { children: rowData.name }),
		/* @__PURE__ */ jsx(DinnerTable.Cell, { children: /* @__PURE__ */ jsxs("div", {
			className: "gap-x-xs inline-flex",
			children: [/* @__PURE__ */ jsxs("div", { children: [
				device.uuid !== rowData.device.uuid ? /* @__PURE__ */ jsx("div", {
					className: "text-color-subtle text-sm font-light capitalize",
					children: rowData.device.type
				}) : /* @__PURE__ */ jsx(Badge, {
					value: "This Browser",
					variant: "info"
				}),
				/* @__PURE__ */ jsx("div", {
					className: "text-sm font-light",
					children: rowData.device.os
				}),
				/* @__PURE__ */ jsx("div", { children: rowData.device.name })
			] }), rowData.connected && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Icon, {
				Icon: MdSensors,
				color: "positive",
				size: "sm"
			}) })]
		}) }),
		/* @__PURE__ */ jsx(DinnerTable.Cell, { children: /* @__PURE__ */ jsx(DateTime$1, {
			relative: true,
			timestamp: rowData.lastUsedAt
		}) }),
		/* @__PURE__ */ jsx(DinnerTable.Cell, { children: /* @__PURE__ */ jsxs("div", {
			className: "inline-flex",
			children: [
				/* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(DateTime$1, {
					relative: true,
					timestamp: rowData.createdAt
				}) }), /* @__PURE__ */ jsx("div", {
					className: "text-color-subtle",
					children: /* @__PURE__ */ jsx(DateTime$1, { timestamp: rowData.createdAt })
				})] }),
				/* @__PURE__ */ jsx("div", {
					className: "mx-base border-neutral-faded border",
					style: { transform: "rotate(15deg)" }
				}),
				/* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(DateTime$1, {
					relative: true,
					timestamp: rowData.expire
				}) }), /* @__PURE__ */ jsx("div", {
					className: "text-color-subtle",
					children: /* @__PURE__ */ jsx(DateTime$1, { timestamp: rowData.expire })
				})] })
			]
		}) }),
		/* @__PURE__ */ jsx(DinnerTable.Cell, { children: !!rowData.clientApps?.length && /* @__PURE__ */ jsx("div", {
			className: "inline-flex w-full justify-center",
			children: /* @__PURE__ */ jsx(Button, {
				onClick: () => onClickAuthSessionClientApps ? onClickAuthSessionClientApps(clientAppsByName) : null,
				variant: "main",
				subtle: true,
				children: Object.keys(clientAppsByName)?.length
			})
		}) }),
		/* @__PURE__ */ jsxs(DinnerTable.Cell, { children: [rowData.hasNotificationToken && /* @__PURE__ */ jsxs("div", {
			className: "gap-xs pl-xxs flex items-center justify-between",
			children: [/* @__PURE__ */ jsxs("span", {
				className: "pr-xs space-x-xxs flex items-center font-bold",
				children: [
					/* @__PURE__ */ jsx(Icon, {
						Icon: MdDone,
						size: "sm"
					}),
					" ",
					/* @__PURE__ */ jsx("span", {
						className: "line-clamp-2",
						children: "Notification Token Registered"
					})
				]
			}), onTestPushNotification && /* @__PURE__ */ jsx("div", {
				className: "pl-xxs",
				children: /* @__PURE__ */ jsx(Button, {
					onClick: () => onTestPushNotification(rowData),
					size: "sm",
					subtle: true,
					variant: "main",
					children: "Test"
				})
			})]
		}), /* @__PURE__ */ jsx("div", {
			className: "flex flex-row flex-wrap text-xs font-light capitalize",
			children: Object.entries(rowData.device.permissions || {}).map(([key, allowed]) => allowed && key).filter((x) => !!x).join(", ")
		})] })
	] }) });
}
//#endregion
export { UserAuthSessionsTableRow };

//# sourceMappingURL=TableRow.js.map